// extracted by mini-css-extract-plugin
module.exports = {"wrap":"CartNotification_wrap__ihwGK","img":"CartNotification_img__LffiU","label":"CartNotification_label__Sdt7P","empty":"CartNotification_empty__S1R5C"};